import type { Saga } from "redux-saga";
import { put } from "redux-saga/effects";

import { appContextActions } from "../actions";

/**
 * Handles app context flows. Currently this includes:
 * Waiting for auth state to be initialized
 * Fetching privacy consent
 * Fetching experimentation data
 * Dispatching actions to indicate that the app context has been bootstrapped
 * Waiting for auth state changes and then fetching privacy consent and experimentation data again as needed
 *
 * This function serves as a centralized handler for actions that need to be performed
 * immediately after the user has been authenticated.
 */
function* innerAppContextSagas() {
  yield put(appContextActions.setBootstrapInitialized());
}

// Need to cast to Saga so it plays happy with sagaMiddleware.run(...)
export const appContextSagas = innerAppContextSagas as Saga;
